<script>
import vClickOutside from "v-click-outside";
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    templates: {},
    fundSources: null,
    campus: {
      type: Number,
    },
  },
  data() {
    return {
      importModal: false,
      fsSelection: false,
      openFS: false,
      selectedFS: null,
      filterFS: "",
      sourceTemplates: [],
    };
  },
  methods: {
    formatCurrency(data) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PHP",
      }).format(data);
    },
    view(record) {
      this.$emit("view", record);
    },
    edit(record) {
      this.$emit("edit", record);
    },
    deleteTemplate(record) {
      this.$emit("delete", record);
    },
    openFSSelection() {
      this.fsSelection = true;
      this.openFS = true;
    },
    closeFS() {
      if (this.fsSelection) {
        this.fsSelection = false;
      }
      this.openFS = false;
    },
    selectFS(row) {
      this.fsSelection = false;
      this.selectedFS = row;
      this.$store
        .dispatch("financeTemplate/getTemplateByFundSource", row.id)
        .then((response) => {
          this.sourceTemplates = response.data;
        })
        .catch(() => {
          this.showToast(
            "Failed to fetch finance templates. Please contact administrator",
            "error"
          );
        });
    },
    selectFSTemplate(row) {
      console.log(row);
    },
    printLIB() {
      this.$emit("printLIB");
    },
  },
  computed: {
    filteredFS() {
      let data = this.fundSources;
      if (this.filterFS.trim() != "" && this.filterFS) {
        data = data.filter((item) => {
          return item.sourceName.toUpperCase().includes(this.filterFS.toUpperCase());
        });
      }
      return data;
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-md-4"
           v-for="template in templates"
           :key="template.id">
        <div class="card task-box"
             id="uptask-1">
          <div class="card-body">
            <div class="float-end">
              <span class="badge rounded-pill badge-soft-success"
                    v-if="template.status && template.status.toLowerCase() === 'posted'">POSTED</span>
              <b-dropdown id="dropdown-dropleft"
                          right
                          variant="link"
                          toggle-class="text-decoration-none"
                          menu-class="dropdown-menu-end"
                          no-caret>
                <template #button-content>
                  <i class="fas fa-ellipsis-v"></i>
                </template>

                <b-dropdown-item variant="info"
                                 @click="view(template)"><i class="mdi mdi-magnify font-size-18 me-3"></i>View
                </b-dropdown-item>
                <!-- <b-dropdown-item variant="purple" @click="printLIB"
                    ><i class="bx bx-printer font-size-18 me-3"></i>Print LIB
                  </b-dropdown-item> -->

                <b-dropdown-item variant="warning"
                                 @click="edit(template)"
                                 v-if="!template.status || template.status.toLowerCase() !== 'posted'"><i
                     class="mdi mdi-square-edit-outline font-size-15 me-3"></i>Edit</b-dropdown-item>
                <b-dropdown-item variant="danger"
                                 @click="deleteTemplate(template)"
                                 v-if="!template.status || template.status.toLowerCase() !== 'posted'"><i
                     class="mdi mdi-trash-can font-size-15 me-3"></i>Delete</b-dropdown-item>
              </b-dropdown>
            </div>
            <div>
              <small class="d-block">Title</small>
              <h5 class="font-size-15 mb-0 text-truncate w-75"
                  :id="`title-${template.id}`">
                <a href="javascript: void(0);"
                   @click="view(template)"
                   class="text-dark">{{ template.title }}</a>
              </h5>
              <b-tooltip :target="`title-${template.id}`"
                         triggers="hover">
                {{ template.title }}
              </b-tooltip>
              <p class="my-0">
                <small class="d-block mt-2">Fund Source</small><span class="text-light">{{ template.fundSource.sourceName
                }}</span>
              </p>
              <p class="text-muted mb-4 mt-0">
                <small class="d-block mt-2">Cycle: </small><span class="badge rounded-pill bg-info">{{ template.cycle
                }}</span>
              </p>
            </div>

            <div class="text-start">
              <h5 class="font-size-14 mb-0 text-warning">
                {{ formatCurrency(template.total) }}
              </h5>
              <p class="mb-0 text-muted font-size-11">Total</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.tooltip {
  opacity: 1 !important;
}

.card-input:hover {
  cursor: pointer;
}

.card-input-element {
  display: none;
}

.card-input-element:checked+.card-input {
  box-shadow: 0 0 1px 1px #2ecc71;
}
</style>
